import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import muiTheme from './MuiTheme'
import { MuiThemeProvider } from '@material-ui/core/styles';
import { Provider } from 'react-redux';
import store from './reduxes/rootReducer'

const Pw = () => <Provider store={store}><MuiThemeProvider theme={muiTheme}><App /></MuiThemeProvider></Provider>

ReactDOM.render(
  <Pw />,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
